<template>
  <el-dialog title="自定义显示列项" width="40%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
    <div class="fontSize12 p_b1">列项显示不得少于1项</div>
    <el-table size="small" ref="dataList" :data="dataList" row-key="id" border v-loading="loading"
              class="table draggable" max-height="550">
      <el-table-column prop="disabled" label="显示">
        <template slot-scope="{ row }">
          <el-checkbox v-model="row.disabled" true-label="0" false-label="1"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="basicName" label="列名" show-overflow-tooltip></el-table-column>
      <el-table-column label="拖动调整顺序">
        <template slot-scope="{ row }">
          <el-link type="primary" icon="el-icon-rank" class="allowDrag" :underline="false"></el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-link class="m_t1 fontSize12" type="primary" :underline="false" @click="restoreDefault()">恢复默认</el-link>
    <div slot="footer" class="text_center">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" :disabled="loading" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import Sortable from 'sortablejs'

  export default {
    data() {
      return {
        visible: false,
        loading: false,
        dataList: [],
        initData: [],
        configId: '',
        basicDataId: '',
      }
    },
    methods: {
      init(list, configId, basicDataId) {
        this.configId = configId
        this.basicDataId = basicDataId
        this.visible = true
        this.dataList = JSON.parse(JSON.stringify(list))
        this.initData = JSON.parse(JSON.stringify(list))
        this.$nextTick(() => {
          this.getTableList();
          this.rowDrop();
        })
      },
      // 获取列数据
      getTableList() {
        this.loading = false
        this.$axios(this.api.metadata.cacheTableList + '?basicDataId=' + this.basicDataId + '&configId=' + this.configId, this.dataList, 'post').then(data => {
          this.loading = false
        })
      },
      // 排序
      rowDrop() {
        const tbody = document.querySelector(".draggable .el-table__body-wrapper tbody");
        const that = this
        new Sortable(tbody, {
          animation: 150,
          ghostClass: "ghostClass",
          handle: ".allowDrag",//设置操作区域
          onEnd({ newIndex, oldIndex }) {
            // 拖拽排序数据
            that.dataList.splice(newIndex, 0, that.dataList.splice(oldIndex, 1)[0])
            const newArray = that.dataList.slice(0)
            that.dataList = []
            that.$nextTick(function () {
              that.dataList = newArray
            })
          }
        })
      },
      // 恢复默认
      restoreDefault() {
        this.dataList = JSON.parse(JSON.stringify(this.initData))
      },
      // 确定
      doSubmit() {
        let list = this.dataList.filter(item => item.disabled == '0')
        if(!list.length) {
          this.$message.warning('列项显示不得少于1项')
          return
        }
        this.loading = true
        this.$axios(this.api.metadata.cacheTableList + '?basicDataId=' + this.basicDataId + '&configId=' + this.configId, this.dataList, 'post').then(data => {
          if (data && data.length) {
            this.$emit('refreshData')
            this.visible = false
          } else {
            this.$message.error(data.msg)
          }
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped>

</style>
